import request from '@/utils/request';

// 用户登录
export function login(data) {
    return request({
        url: '/heart/system_login',
        method: 'POST',
        data
    });
}

// 心率监控系统
export function getInfo(params) {
    return request({
        url: '/heart/getHeartRateMonitorInfo',
        method: 'get',
        params
    });
}

// 获取心率强度区间
export function getStrength() {
    return request({
        url: '/getStrength',
        method: 'get'
    });
}

// 心率系统登录信息
export function system(params) {
    return request({
        url: '/heart/system_login',
        method: 'get',
        params
    });
}

// 获取机构门店
export function getStoreList(params) {
    return request({
        url: '/heart/agencyStoreList',
        method: 'get',
        params
    });
}

// 获取备案号
export function getConfig() {
    return request({
        url: '/heart/system_login',
        method: 'get'
    });
}

// 监控系统保存记录
export function saveRecord(data) {
    return request({
        url: '/heart/saveUserSportRecord',
        method: 'POST',
        data
    });
}

// 运动前2小时的血糖图表
export function getChartDate(params) {
    return request({
        url: '/sino/sports_chart_data',
        method: 'get',
        params
    });
}